<template>
    <th :class="['table-header-cell', textAlignClass]">
        <slot />
    </th>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "vue";
import type { Align } from "@/types/alignment";

export default defineComponent({
    name: "TableHeaderCell",
    props: {
        align: {
            type: String as PropType<Align>,
            default: "left",
        },
    },
    setup(props) {
        const textAlignClass = computed(() => {
            return (
                {
                    left: "text-left",
                    center: "text-center",
                    right: "text-right",
                }[props.align] || ""
            );
        });

        return {
            textAlignClass,
        };
    },
});
</script>

<style>
@import "@/style/data-tables.css";
</style>
